import { useReadyValue } from '@finn/platform-modules';
import {
  CookieKeys,
  getClientBooleanCookie,
  setClientBooleanCookie,
} from '@finn/ui-utils';

import { GenericVehicleDetails, VehicleSizes } from './modules/core';

const EXPIRATION_DAYS = 30;

export const setForBusinessCookie = (value: boolean) =>
  setClientBooleanCookie(CookieKeys.IS_FOR_BUSINESS, value, EXPIRATION_DAYS);

export const getForBusinessCookie = () =>
  getClientBooleanCookie(CookieKeys.IS_FOR_BUSINESS);

export const useForBusinessCookie = () => {
  return useReadyValue(getForBusinessCookie(), false);
};

export const getVehicleSize = (
  vehicle: Pick<GenericVehicleDetails, 'brand' | 'model' | 'config_id'>,
  vehicleSizes: VehicleSizes
) => {
  const vehicleSize =
    vehicleSizes?.[vehicle.config_id] ||
    vehicleSizes?.average_sizes[`${vehicle.brand.id}-${vehicle.model}`] ||
    vehicleSizes?.average_sizes[vehicle.brand.id] ||
    vehicleSizes?.total_avg;

  return vehicleSize;
};
